import ptApiClient from 'plant-api-client';
import { getContentId } from '../../../../../utils/dbTool';

export function moveContent(item, parentId) {
	return ptApiClient.updateContent(getContentId(item), { folder_id: parentId });
}